import { Box } from '@/common/components';
import { styled } from '@/stitches.config';

export const StyledContainer = styled(Box, {
  display: 'flex',
  height: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
});
